import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchAll(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/store/issues', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchOne(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/store/issues/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    add(ctx, issueData) {
      return new Promise((resolve, reject) => {
        axios
          .post('/store/issues', issueData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    edit(ctx, issueData) {
      return new Promise((resolve, reject) => {
        const url = `/store/issues/${issueData.id}`
        axios
          .put(url, issueData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    del(ctx, id) {
      return new Promise((resolve, reject) => {
        const url = `/store/issues/${id}`
        axios
          .delete(url)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

  },
}
